import type { ReactNode } from "react";
import { token } from "@/design/theme";

/** A consistent screen header: title + optional subtitle + right-aligned actions. */
export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: token.s4,
        flexWrap: "wrap",
        marginBlockEnd: token.s5,
      }}
    >
      <div style={{ flex: "1 1 auto" }}>
        <h1 style={{ fontSize: token.fsH1, margin: 0 }}>{title}</h1>
        {subtitle && (
          <p style={{ color: token.slate, margin: 0, marginBlockStart: token.s1 }}>{subtitle}</p>
        )}
      </div>
      {actions && <div style={{ display: "flex", gap: token.s2, flexWrap: "wrap" }}>{actions}</div>}
    </header>
  );
}
